var _path, _path2, _g, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChatIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 143,
    height: 117,
    viewBox: "0 0 143 117",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124.295 26.125C132.338 26.125 138.859 32.6577 138.859 40.7162V81.6934C138.859 89.2458 133.131 95.458 125.791 96.2087V111.719L105.846 96.2846H60.5719C52.5284 96.2846 46.0078 89.7514 46.0078 81.6934V40.7162C46.0078 32.6577 52.5284 26.125 60.5719 26.125H124.295Z",
    fill: "#A2B7EC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.1734 2.06836C9.12991 2.06836 2.60938 8.60109 2.60938 16.6596V67.8481C2.60938 75.9066 9.12991 82.439 17.1734 82.439H17.1802V100.121L39.4199 82.439H91.5752C99.6182 82.439 106.139 75.9066 106.139 67.8481V16.6596C106.139 8.60109 99.6182 2.06836 91.5752 2.06836H17.1734Z",
    fill: "#A2B7EC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_399_61812)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.4557 66.2495C68.5265 66.2495 79.1224 55.6339 79.1224 42.5388C79.1224 29.4438 68.5265 18.8281 55.4557 18.8281C42.385 18.8281 31.7891 29.4438 31.7891 42.5388C31.7891 55.6339 42.385 66.2495 55.4557 66.2495Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_399_61812)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.8203 49.3913C57.5297 50.6264 62.0542 52.2254 66.4773 48.7402",
    stroke: "url(#paint0_linear_399_61812)",
    strokeWidth: 2.62264,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_399_61812",
    x: 28.2922,
    y: 17.0797,
    width: 54.3257,
    height: 54.4156,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.74843
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.74843
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.298039 0 0 0 0 0.454902 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_399_61812"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_399_61812",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_399_61812",
    x: 51.011,
    y: 45.6813,
    width: 20.275,
    height: 11.73,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.74843
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.74843
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.298039 0 0 0 0 0.454902 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_399_61812"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_399_61812",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_399_61812",
    x1: 55.4033,
    y1: 49.8633,
    x2: 63.4776,
    y2: 50.7065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#70A9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C74FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatIcon);
export default __webpack_public_path__ + "static/media/chat-icon.4f33c302bb71b84c9091e3058b2d820c.svg";
export { ForwardRef as ReactComponent };